<template>
  <div class="collab-backdrop" @click.self="close">
    <div class="collab-modal">
      <div class="collab-head">
        <h3>협업 신청</h3>
        <button type="button" class="collab-close" @click="close" aria-label="닫기">×</button>
      </div>
      <div class="collab-desc">
        <p>ART &amp; ARTISTS 페이지에서 마음에 드는 아티스트나 작품을 발견하셨나요?</p>
        <p>mimio에 아직 등록되어 있진 않지만 협업하고 싶은 아티스트가 있으신가요? (아트 컬래버레이션, 상품 개발 등)</p>
        <p>어떻게 연락해야 할지, 조건은 어떤 방식으로 협의해야 할지 막막하다면 아래 내용을 보내주세요.</p>
        <p>ART IP 중개 전문 기업 아티클21에서 성공적인 협업을 도와드립니다.</p>
      </div>

      <div class="collab-body">
        <div class="input-wrap">
          <span>이름 <em>*</em></span>
          <input type="text" v-model="collab.name" class="input-cs" placeholder="이름을 입력해주세요." />
        </div>
        <div class="input-wrap">
          <span>연락처 <em>*</em></span>
          <input
            type="tel"
            v-model="collab.phoneNum"
            @input="formatPhoneNumber"
            class="input-cs"
            placeholder="010-0000-0000"
          />
        </div>
        <div class="input-wrap">
          <span>이메일 <em>*</em></span>
          <input type="email" v-model="collab.email" class="input-cs" placeholder="답변받을 이메일 주소" />
        </div>
        <div class="input-wrap">
          <span>기업명</span>
          <input type="text" v-model="collab.companyName" class="input-cs" placeholder="기업명 (해당 시)" />
        </div>
        <div class="input-wrap">
          <span>관심 아티스트/작품</span>
          <input
            type="text"
            v-model="collab.interestArtist"
            class="input-cs"
            placeholder="관심 아티스트명 또는 작품명"
          />
        </div>
        <div class="input-wrap">
          <span>기타 문의 사항</span>
          <textarea v-model="collab.content" placeholder="문의하실 내용을 자유롭게 적어주세요."></textarea>
        </div>
        <div class="input-wrap">
          <span>연락받길 원하는 시간</span>
          <div class="collab-radio">
            <label v-for="opt in timeOptions" :key="opt.value">
              <input type="radio" name="collab-time" :value="opt.value" v-model="collab.preferredContactTime" />
              <span>{{ opt.label }}</span>
            </label>
          </div>
        </div>

        <div v-if="!isLogin" class="input-wrap">
          <span class="checkbox-type3">
            <input v-model="isChecked" type="checkbox" id="collab-privacy" />
            <label for="collab-privacy">
              <span>개인정보 수집 및 이용 동의</span>
              <span class="sub" :style="!isChecked ? 'color:red' : ''"
                >답변을 받으시려면 동의해주세요.</span
              >
            </label>
          </span>
        </div>

        <div class="input-wrap">
          <button type="button" class="collab-submit" :disabled="!isChecked" @click="submit">
            <span>신청하기</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { collabApplyFunction } from "@/composables/collabApplyFunction";

const emit = defineEmits(["close"]);

const { isLogin, collab, loadProfile, saveCollab, formatPhoneNumber } = collabApplyFunction();
const isChecked = ref(isLogin || false);

const timeOptions = [
  { value: "MORNING", label: "오전(09:00~12:00)" },
  { value: "AFTERNOON", label: "오후(13:00~18:00)" },
  { value: "ETC", label: "기타" },
];

const close = () => emit("close");
const submit = () => saveCollab(close);

onMounted(() => {
  loadProfile();
});
</script>

<style scoped>
.collab-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.collab-modal {
  width: 100%;
  max-width: 440px;
  max-height: 88vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px 24px;
  box-sizing: border-box;
}
.collab-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.collab-head h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111;
}
.collab-close {
  font-size: 26px;
  line-height: 1;
  color: #888;
  background: none;
  border: none;
  cursor: pointer;
}
.collab-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 18px;
}
.collab-desc p {
  margin: 0 0 10px;
}
.collab-desc p:last-child {
  margin-bottom: 0;
  color: #333;
  font-weight: 600;
}
/* 전역 .input-wrap/.input-cs 는 .modal-cs 하위로 스코프돼 있어 여기선 안 먹음 → 자체 정의 */
.collab-body .input-wrap {
  display: block;
  margin-bottom: 16px;
}
.collab-body .input-wrap > span {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}
.collab-body .input-wrap > span em {
  color: #f0413e;
  font-style: normal;
}
.collab-body .input-cs {
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  font-size: 14px;
  color: #111;
  background: #fff;
}
.collab-body textarea {
  width: 100%;
  min-height: 96px;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #111;
  background: #fff;
  resize: vertical;
}
.collab-body .input-cs:focus,
.collab-body textarea:focus {
  outline: none;
  border-color: #111;
}
.collab-body .input-cs::placeholder,
.collab-body textarea::placeholder {
  color: #b3b3b3;
}
/* 개인정보 동의 — 라벨 인라인 정렬(체크박스 옆) */
.collab-body .checkbox-type3 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.collab-body .checkbox-type3 input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex: 0 0 auto;
}
.collab-body .checkbox-type3 label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.collab-body .checkbox-type3 label .sub {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}
.collab-radio {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.collab-radio label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.collab-radio input[type="radio"] {
  width: auto;
  margin: 0;
}
.collab-submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 10px;
  background: #111;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.collab-submit:disabled {
  background: #ddd;
  color: #999;
  cursor: not-allowed;
}
</style>
